/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dataprocessProcess
 */
export interface DataprocessProcess { 
    id?: number;
    /**
     * id of dataprocesssGroup
     */
    dataprocessGroupId?: number;
    /**
     * name of the dataprocessProcess
     */
    name?: string;
    /**
     * description of the dataprocessProcess
     */
    description?: string;
    /**
     * jsonString for the icon of the dataprocessProcesses
     */
    icon?: string;
    /**
     * the dataprocessProcesses are sorted according to this value
     */
    sort?: number;
}

